import { useEffect, useState } from 'react';

import Button from '@cobliteam/ui/components/Button';
import { Input } from '@cobliteam/ui/form';
import { useDebounce } from '@cobliteam/ui/hooks';
import Icon from '@cobliteam/ui/icons';

export interface DataTableSearchInputProps {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
}

const DataTableSearchInput = ({ value, placeholder, onChange }: DataTableSearchInputProps) => {
  const [searchValue, setSearchValue] = useState<string>(value);
  const debouncedValue = useDebounce(searchValue, 500);

  useEffect(() => {
    onChange(debouncedValue);
  }, [debouncedValue]);

  // Add effect to update internal state when prop changes
  useEffect(() => {
    setSearchValue(value);
  }, [value]);

  return (
    <Input
      autoFocus
      data-testid='datatable-search'
      startIcon={<Icon name='search' />}
      placeholder={placeholder}
      defaultValue={value}
      value={searchValue}
      className='w-full min-w-72 max-w-96'
      endIcon={searchValue ? <Button data-testid='clear-search' variant='ghost' color='default' icon={<Icon name='x' />} size='sm' onClick={() => setSearchValue('')} /> : null}
      onChange={(e) => setSearchValue(e.target.value)}
    />
  );
};

export default DataTableSearchInput;
